(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  const hamburger = document.querySelector('.sp-header__hamburger');
  const mobileMenu = document.querySelector('.sp-header__mobile-menu');
  const closeBtn  = document.querySelector('.sp-header__close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      this.classList.toggle('is-active');
      mobileMenu.classList.toggle('is-open');

      const isExpanded = this.classList.contains('is-active');
      this.setAttribute('aria-expanded', isExpanded);

      if (isExpanded) document.body.classList.add('sp-menu-open');
      else document.body.classList.remove('sp-menu-open');
    });

    const mobileLinks = mobileMenu.querySelectorAll('.sp-header__mobile-link');
    mobileLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        hamburger.classList.remove('is-active');
        mobileMenu.classList.remove('is-open');
        document.body.classList.remove('sp-menu-open');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        hamburger.classList.remove('is-active');
        mobileMenu.classList.remove('is-open');
        document.body.classList.remove('sp-menu-open');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    }
  }
});


  } catch(e) { console.error(e); }
})();
})();
